declare global {
  interface Window {
    dataLayer?: object[];
  }
}
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer ?? [];
}
interface LoginEvent {
  name: "login";
  method: "email" | "facebook" | "google" | "apple";
}

interface SignUpEvent {
  name: "sign_up";
  method: "email" | "facebook" | "google" | "apple";
}

interface AccountActivatedEvent {
  name: "my_espc_account_activated";
  value: number;
}

interface ValuationsLandingPageFormSubmitEvent {
  name: "valuations_landing_page_form_submit";
  value: number;
}

interface ValuationLeadSubmittedEvent {
  name: "valuation_lead_submitted";
  value: number;
}

type AnalyticsEvent =
  | LoginEvent
  | SignUpEvent
  | AccountActivatedEvent
  | ValuationsLandingPageFormSubmitEvent
  | ValuationLeadSubmittedEvent;

export function TrackEvent(event: AnalyticsEvent): void {
  const evt: Record<string, string> = { event: event.name };

  for (const key in event) {
    if (key !== "name") {
      const parameterName = key as keyof typeof event;
      evt[key] = event[parameterName];
    }
  }

  window.dataLayer?.push(evt);

  // reset datalayer parameters after pushing
  // otherwise parameters will be sent with all events (they persist on the page until the page is refreshed)
  window.dataLayer?.push(function (this: DataLayer) {
    this.reset();
  });
}
